import { ThemeProvider } from '@emotion/react';
import { Avatar, Chip } from '@mui/material';
import Grid from '@mui/material/Grid';
import { createTheme, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import BigNormalButton from 'components/atoms/Button/BigNormalButton';
import SuperScriptStrAlt from 'components/atoms/String/SuperScriptStrAlt';
import IntroSection from 'components/organisms/IntroSection';
import NftPrometheus from 'components/organisms/NftPrometheus';
import * as React from 'react';
import Media from 'react-media';
import 'swiper/css';
import 'swiper/css/pagination';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#ddb930',
      light: '#cccccc3d',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const Body = styled('article')(({ theme }) => ({
  position: 'relative',
  display: 'block',
  backgroundColor: '#292739',
  width: '100%',

  // marginTop: "130px",
}));

const HomeBody = () => {
  const userImg = require('assets/Profile/buku_default_avatar.png');
  const bgImage1 = require('assets/HomePage/bg1.png');
  const bgImage2 = require('assets/HomePage/bg2.png');

  const HomeSection = styled(Grid)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    padding: '0rem 10%',
    minHeight: '50vh',
    '&:nth-child(1)': {
      paddingTop: '130px',
    },
    [theme.breakpoints.down('lg')]: {
      padding: '0rem 8%',
    },
    [theme.breakpoints.down('md')]: {
      padding: '0rem 5%',
      '&:nth-child(1)': {
        paddingTop: '20px',
      },
    },
  }));

  // const HomeSectionSpaced = styled(HomeSection)(({ theme }) => ({
  //   padding: '5rem 10%',
  //   [theme.breakpoints.down('lg')]: {
  //     padding: '5rem 8%',
  //   },
  //   [theme.breakpoints.down('md')]: {
  //     padding: '5rem 5%',
  //   },
  // }));

  const HomeSubSection = styled(Grid)(({ theme }) => ({
    display: 'flex',
    borderRadius: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',

    marginBottom: '3rem',
  }));

  const SectionImage = styled(Grid)(({ theme }) => ({
    display: 'flex',
    borderRadius: '20px',
    justifyContent: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    height: '60vh',
    width: '100%',
    boxShadow: theme.shadows[8],
  }));

  const HomeText = styled('div')(({ theme }) => ({
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      paddingRight: '0rem !important',
      paddingLeft: '0rem !important',
    },
  }));

  const TitleText = styled(Typography)(({ theme }) => ({
    color: '#ffffff',
    fontSize: '3rem',
    fontWeight: 'bold',
    marginBottom: '20px',
  }));

  const ParaText = styled(TitleText)(({ theme }) => ({
    fontSize: '1.1rem',
    fontWeight: 'lighter',
    marginBottom: '20px',
    color: '#e5e5e5',
    [theme.breakpoints.down('md')]: {
      fontSize: '.9rem',
    },
  }));

  const LightChip = styled(Chip)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.light,
    color: '#fff',
  }));

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Body
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Media query="(max-width: 599px)">
            {matches =>
              matches ? (
                <HomeSection
                  container
                  sx={{
                    backgroundImage: `linear-gradient(to bottom, rgba(41,39,57,0.6) 0%,rgba(41,39,57,0.8) 100%), url(${bgImage1})`,
                    minHeight: '100vh',
                  }}
                >
                  <IntroSection />
                  <Grid item xs={12} md={6}>
                    <HomeSubSection>
                      <SectionImage
                        style={{ backgroundImage: `url(${bgImage1})` }}
                      ></SectionImage>
                    </HomeSubSection>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <HomeSubSection>
                      <HomeText style={{ paddingRight: '5rem' }}>
                        <TitleText style={{ fontSize: '2.5rem' }}>
                          Buku Genesis NFT
                        </TitleText>
                        <ParaText>
                          The ticket to the future of social media. An Ecosystem
                          for content creators.
                        </ParaText>
                        <ParaText>
                          Mint to claim your username and receive 1/1000 genesis
                          NFTs
                        </ParaText>
                        <BigNormalButton
                          text={'Get Mint'}
                          color={'yellow'}
                          style={{ maxWidth: '150px' }}
                        />
                      </HomeText>
                    </HomeSubSection>
                  </Grid>
                </HomeSection>
              ) : (
                <div
                  style={{
                    width: '100%',
                    overflowX: 'hidden',
                  }}
                >
                  <IntroSection />
                  <NftPrometheus />
                  <HomeSection
                    container
                    sx={{
                      backgroundImage: `linear-gradient(to bottom, rgba(41,39,57,0.6) 0%,rgba(41,39,57,0.8) 100%), url(${bgImage1})`,
                      minHeight: '100vh',
                    }}
                  >
                    <Grid item xs={12} md={6}>
                      <HomeSubSection>
                        <HomeText style={{ paddingRight: '5rem' }}>
                          <TitleText>Buku Genesis NFT</TitleText>
                          <ParaText>
                            The ticket to the future of social media. An
                            Ecosystem for content creators.
                          </ParaText>
                          <ParaText>
                            Mint to claim your username and receive 1/1000
                            genesis NFTs
                          </ParaText>
                          <BigNormalButton
                            text={'Get Mint'}
                            color={'yellow'}
                            style={{ maxWidth: '150px' }}
                          />
                        </HomeText>
                      </HomeSubSection>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <HomeSubSection>
                        <SectionImage
                          style={{ backgroundImage: `url(${bgImage1})` }}
                        ></SectionImage>
                      </HomeSubSection>
                    </Grid>
                  </HomeSection>
                </div>
              )
            }
          </Media>
          <Media query="(max-width: 599px)">
            {matches =>
              matches ? (
                <HomeSection
                  container
                  style={{
                    backgroundImage: `linear-gradient(to bottom, rgba(41,39,57,0.6) 0%,rgba(41,39,57,0.8) 100%), url(${bgImage2})`,
                    minHeight: '100vh',
                  }}
                >
                  <Grid item xs={12} md={6}>
                    <HomeSubSection>
                      <SectionImage
                        style={{ backgroundImage: `url(${bgImage2})` }}
                      ></SectionImage>
                    </HomeSubSection>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <HomeSubSection>
                      <HomeText style={{ paddingLeft: '5rem' }}>
                        <TitleText style={{ fontSize: '2.5rem' }}>
                          #991 Sky Phenomen
                        </TitleText>
                        <ParaText>
                          Created by
                          <LightChip
                            avatar={<Avatar alt="@leahx1621" src={userImg} />}
                            label="@leahx1621"
                            style={{ marginLeft: '10px' }}
                          />
                        </ParaText>
                        <Grid container style={{ marginBottom: '3rem' }}>
                          <Grid item xs={6}>
                            <ParaText style={{ marginBottom: '.8rem' }}>
                              RESERVE PRICE
                            </ParaText>

                            <SuperScriptStrAlt
                              text={'0.11'}
                              sup={'ETH'}
                              style={{
                                color: '#e5e5e5',
                              }}
                              textSize={'1.8rem'}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <ParaText style={{ marginBottom: '.8rem' }}>
                              AUCTION ENDS IN
                            </ParaText>
                            <SuperScriptStrAlt
                              text={'1'}
                              sup={'HR'}
                              style={{
                                color: '#e5e5e5',
                                marginRight: '5px',
                              }}
                              textSize={'1.8rem'}
                            />
                            <SuperScriptStrAlt
                              text={'15'}
                              sup={'MN'}
                              style={{
                                color: '#e5e5e5',
                                marginRight: '5px',
                              }}
                              textSize={'1.8rem'}
                            />
                            <SuperScriptStrAlt
                              text={'1'}
                              sup={'S'}
                              style={{
                                color: '#e5e5e5',
                                marginRight: '5px',
                              }}
                              textSize={'1.8rem'}
                            />
                          </Grid>
                        </Grid>
                        <BigNormalButton
                          text={'Get Mint'}
                          color={'yellow'}
                          style={{ maxWidth: '150px' }}
                        />
                      </HomeText>
                    </HomeSubSection>
                  </Grid>
                </HomeSection>
              ) : (
                <></>
              )
            }
          </Media>

          {/* <HomeSectionSpaced container style={{ maxWidth: '1720px' }}>
            <FeaturedArtists />
          </HomeSectionSpaced> */}
          {/* <HomeSectionSpaced container style={{ maxWidth: '1820px' }}>
            <Auctions />
          </HomeSectionSpaced>
          <RoadmapBody /> */}
        </Body>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default HomeBody;
